import React from 'react';
import { Flame } from 'lucide-react';
export function UrgencyBar() {
  return <div className="bg-cf-red text-white py-2 px-4 text-center flex items-center justify-center gap-2 font-bold text-sm md:text-base uppercase tracking-wider" data-id="element-374">
      <Flame className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-375" />
      <span className="text-[9px] font-[900]" data-id="element-376">
        Precio de lanzamiento activo por tiempo limitado
      </span>
      <Flame className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-377" />
    </div>;
}